import _lib from '../_lib';
import {CdaNavigation,CdasNavigation} from '@/store/modules/fsm/messages';
import { clearCda } from '@/mutation-types';
import active from './active/index';

export default ({tree,parent,api}) => {
  let regionName = 'cdas';
  let activations = [
    {
      name: 'cda',
      test: api.messageIs(CdaNavigation)
    },
    {
      name: 'cdas',
      test: api.messageIs(CdasNavigation)
    },
  ];
  let activeIndex = active;
  let readyToDormant = ({context}) => context.commit(`login/cda/${clearCda}`,null,{root:true});
  let func = _lib({regionName,activations,activeIndex,readyToDormant});
  return func({tree,parent,api});
};
